export default {
  REACT_APP_LINK_HOST: process.env.REACT_APP_LINK_HOST,
  REACT_APP_PLAYBOOK_HOST: process.env.REACT_APP_PLAYBOOK_HOST,
};
